import { AllFeatureIds } from 'generated/featureIds.generated'

export const ShiftManagementFeatureFlags = {
  DEV_LOCATION_WORK_AREAS: 'dev_location_work_areas',
  DEV_SHIFT_MANAGEMENT_AUTOMATION: 'dev_shift_management_automation',
  DEV_SHIFT_MANAGEMENT_GRAPHQL_MIGRATION: 'dev_shift_management_graphql_migration',
  DEV_SHIFT_MANAGEMENT_OVER_PLANNED_ALERT: 'dev_shift_management_over_planned_alert',
  DEV_TIME_PLANNING_BALANCES_IN_SHIFTS: 'dev_time_planning_balances_in_shifts',
  DEV_TIME_PLANNING_BANK_OF_HOURS: 'dev_time_planning_bank_of_hours',
  SHIFT_MANAGEMENT_AREA_VIEW: 'shift_management_area_view',
  SHIFT_MANAGEMENT_BACKUP_SHIFTS: 'shift_management_backup_shifts',
  SHIFT_MANAGEMENT_COLOURS_FOR_SHIFTS: 'shift_management_colours_for_shifts',
  SHIFT_MANAGEMENT_DAILY_VIEW: 'shift_management_daily_view',
  SHIFT_MANAGEMENT_MONTHLY_VIEW: 'shift_management_monthly_view',
  SHIFT_MANAGEMENT_REST_DAY: 'shift_management_rest_day',
  TIME_SETTINGS_BREAKS: 'time_settings_breaks',
  TIMEOFF_POLICY_TIMELINE: 'timeoff_policy_timeline',
} as const satisfies Record<string, AllFeatureIds>

const featureFlagValues = Object.values(ShiftManagementFeatureFlags)

export type ShiftManagementFeatureFlagIds = (typeof featureFlagValues)[number]
